module.exports = __webpack_public_path__ + "static/Preowned-053c81ace4f92a506c6550c4d5489e63.pdf";